export function required(label: string) {
  return (value: string) => (value.trim() ? null : `Please enter your ${label}.`)
}

export function email(value: string) {
  if (!value.trim()) return 'Please enter your email.'
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim()) ? null : 'Please enter a valid email address.'
}
